export default class extends Controller {
  static targets = ['closeLink'];

  connect() {
    if (this.openOnConnect) this.openSlideOut()
  }

  openSlideOut(event, url=this.url) {
    event && event.preventDefault()
    App.SlideOut.open({
      element: this.element,
      headerColor: this.data.get("color"),
      title: this.data.get("title"),
      fullWidth: this.fullWidth,
      contentURL: url,
      contentHTML: this.contentHTML
    })
  }

  //
  // GETTERS AND SETTERS
  //

  get url() {
    const url = this.baseURL
    return url ? App.Helpers.addParamsToURL(url, {
      is_multi_account: this.isMultiAccount ? '1' : null
    }) : null;
  }

  get baseURL() {
    return this.element.href
  }

  get openOnConnect() {
    return [1, "1", true, "true"].includes(this.data.get("open-on-connect"))
  }

  get container() {
    return document
  }

  get fullWidth() {
    return this.data.get("full-width")
  }

  get contentHTML() {
    return this.data.get("content-html")
  }
}



// WEBPACK FOOTER //
// ./app/components/controls/assets/javascript/controls-details-slide-out-opener-controller.js